module.exports = __webpack_public_path__ + "img/not-pictured-large.5794f64c.png";